import axios from 'axios';
import validator from 'validator';

const elements = {
    triggers: document.querySelectorAll('.development-card--coming-soon, .register-interest-trigger'),
    modal: document.querySelector('.registerInterestModal__overlay'),
    modalActiveState: 'registerInterestModal__overlay--active',
    modalTitle: document.querySelector('.registerInterestModal__title'),
    modalDevelopmentId: document.querySelector('#registerInterestModal__developmentId'),
    modalForm: document.querySelector('.registerInterestModal__form'),
    modalSubmit: document.querySelector('#registerInterestModal__submit'),
    modalErrors: document.querySelector('.registerInterestModal__errors'),
    modalSuccess: document.querySelector('.registerInterestModal__success'),
    closeButton: document.querySelector('.registerInterestModal__closeModal')
}

const submitRegisterInterestModal = () => {

    let errors = validateFields();

    if (errors.length != 0) {

        elements.modalErrors.querySelector('ul').innerHTML = ''

        errors.map((error) => {
            elements.modalErrors.querySelector('ul').innerHTML += `<li>${error}</li>`
        })

        elements.modalErrors.style.display = 'block'

        return false;
    }

    let form_data = new FormData();

    form_data.append(
        'name',
        elements.modalForm.querySelector('input[name="name"]').value
    )

    form_data.append(
        'email',
        elements.modalForm.querySelector('input[name="email"]').value
    )

    form_data.append(
        'phone',
        elements.modalForm.querySelector('input[name="phone"]').value
    )

    form_data.append(
        'consent',
        elements.modalForm.querySelector('input[name="consent"]').checked
    )

    form_data.append(
        'development_id',
        elements.modalForm.querySelector('input[name="development_id"]').value
    )

    return axios.post( elements.modalForm.querySelector('form').action, form_data)

}


function RegisterInterestModal () {

    let { closeButton } = elements;

    if (typeof elements.triggers != "undefined" && elements.triggers != null) {
        Array.prototype.forEach.call(elements.triggers, (trigger) => {
            trigger.addEventListener('click', (e) => {
                e.preventDefault();
                elements.modalTitle.innerText = trigger.dataset.title + ' is coming soon!'
                elements.modalDevelopmentId.value = trigger.dataset.development_id
                elements.modal.classList.add(elements.modalActiveState)
            });
        });
    }

        document.addEventListener('click', (e) => {
            if (elements.modal.classList.contains(elements.modalActiveState))
            if (e.target.classList.contains(elements.modalActiveState)) elements.modal.classList.remove(elements.modalActiveState)
        });

        document.addEventListener('keydown', (e) => {
            if (elements.modal.classList.contains(elements.modalActiveState))
            if (e.key === "Escape") elements.modal.classList.remove(elements.modalActiveState)
        });

    if (typeof closeButton != "undefined" && closeButton != null) {
        closeButton.addEventListener('click', () => {
            elements.modal.classList.remove(elements.modalActiveState)
        });
    }

    if ( elements.modalSubmit ) {

        elements.modalSubmit.addEventListener('click', (e) => {
            e.preventDefault()

            submitRegisterInterestModal().then((response) => {

                elements.modalErrors.style.display = 'none'
                elements.modalSuccess.style.display = 'none'

                if (response.data === true) {

                    elements.modalSuccess.style.display = 'block'

                } else {

                    elements.modalErrors.querySelector('ul').innerHTML = '<li>An error occured when submitting your form. Please try again later.</li>'

                    elements.modalErrors.style.display = 'block'

                }

            })

        });
    }
}

const validateFields = () => {

    const name = document.querySelector('.registerInterestModal__form input[name="name"]').value;
    const email = document.querySelector('.registerInterestModal__form input[name="email"]').value;
    const phone = document.querySelector('.registerInterestModal__form input[name="phone"]').value;

    let errors = [];

    if (validator.isEmpty(name)) {
        errors.push('The name field is required');
    }

    if (validator.isEmpty(email)) {
        errors.push('The email field is required');
    }

    if (!validator.isEmail(email)) {
        errors.push('The email field must be a valid email');
    }

    if (validator.isEmpty(phone)) {
        errors.push('The telephone field is required');
    }

    return errors;

}

export default RegisterInterestModal;


// WEBPACK FOOTER //
// ./src/js/app/components/RegisterInterest.js